import React from 'react'

export default function 
({open, index, name, radio, description, img, select, conductor}) {


  return (
    <div onClick={() => {
        select(index)
    }} className={`slider-item ${open === index ? "slider-item-open" : "" } `}>

<img src={img} className={`slider-img ${open === index ? "opacity100" : "" }`} alt="" />

    
        <p className='slider-title'> {name} </p>
        {open === index ?  
        
        <>
          
        <p className='slider-subtitle2'> {conductor} </p>
        <p className='slider-subtitle'> {radio} </p>
        <p className='slider-text'> {description} </p> 
        </>
       : <></>}
       
    </div>
  )
}
